import { render } from "./CounterField.vue?vue&type=template&id=af4e7c10"
import script from "./CounterField.vue?vue&type=script&lang=js"
export * from "./CounterField.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__